import React, { useState } from 'react'
import {
    Badge,
    Button,
    Drawer,
    Dropdown,
    Notification,
    Progress,
    toast,
} from 'components/ui'
import SidePanelContent from './SidePanelContent'
import withHeaderItem from 'utils/hoc/withHeaderItem'
import {
    setAuthPanelLoginExpand,
    setAuthPanelSignupExpand,
    setPanelExpand,
    setSideNavCollapse,
} from 'store/theme/themeSlice'
import { useSelector, useDispatch, shallowEqual } from 'react-redux'
import { RiMenuUnfoldLine, RiVipCrownFill } from 'react-icons/ri'
import { IconText } from 'components/shared'
import {
    setChangePackageTo,
    setPlanPanelExpand,
} from 'store/checkout/selectPlanSlice'
import { clearCheckout } from 'store/checkout/titlesSlice'
import { apiSaveSubscriptionChanges } from 'services/CommonService'
import { setSubscription } from 'store/base/commonSlice'
import TitlesProgress from 'views/user/SearchTitlesFeed/TitlesProgress'
import useResponsive from 'utils/hooks/useResponsive'
import { USER } from 'constants/roles.constant'

export const SidePanel = () => {
    const [loading, setLoading] = useState(false)
    const userAuthority = useSelector((state) => state.auth.user.authority)

    const dispatch = useDispatch()
    const subscription = useSelector((state) => state.base.common.subscription)

    const panelExpand = useSelector((state) => state.theme.panelExpand)

    const direction = useSelector((state) => state.theme.direction)
    const { windowWidth } = useResponsive()

    const selectedTitles = useSelector(
        (state) => state.checkout.titles.selectedTitles,
        shallowEqual
    )
    const premiumTitlesCount = useSelector(
        (state) => state.checkout.titles.premiumTitlesCount
    )
    const standardTitlesCount = useSelector(
        (state) => state.checkout.titles.standardTitlesCount
    )

    const closePanel = () => {
        dispatch(setPanelExpand(false))
        const bodyClassList = document.body.classList
        if (bodyClassList.contains('drawer-lock-scroll')) {
            bodyClassList.remove('drawer-lock-scroll', 'drawer-open')
        }
    }

    const dropdownItems = [
        { key: 'a', name: 'Item A' },
        { key: 'b', name: 'Item B' },
        { key: 'c', name: 'Item C' },
        { key: 'd', name: 'Item D' },
    ]
    const onDropdownItemClick = (eventKey, e) => {
        console.log('Dropdown Item Clicked', eventKey, e)
    }

    const onDropdownClick = (e) => {
        console.log('Dropdown Clicked', e)
    }

    const saveSubscriptionChanges = async () => {
        setLoading(true)
        const response = await apiSaveSubscriptionChanges({
            selectedTitles: selectedTitles.map((title) => title.id),
            premiumTitlesCount,
            standardTitlesCount,
        })

        if (response.data.updated === true) {
            closePanel()
            dispatch(clearCheckout())
            dispatch(setSubscription(response.data.subscription))
        }

        setLoading(false)

        const toastNotification = (
            <Notification
                title="Titles"
                type={response.data.updated === true ? 'success' : 'danger'}
                closable
                duration={10000}
            >
                <div>{response.data.msg}</div>
            </Notification>
        )
        toast.push(toastNotification)
    }

    const Footer = (
        <div className="w-full bg-white">
            <div className=" border-slate-200 mx-4 m-auto">
                <div className="flex-grow  my-2">
                    <h4 className="font-semibold">Your Title Feed</h4>
                </div>

                <div className="my-0 flex flex-col gap-3 bg-white py-5 rounded-md ">
                    <TitlesProgress cartView={true} />
                </div>
                <div className="mt-4">
                    {subscription?.id ? (
                        subscription.package.premium_num > 0 &&
                        subscription.package.standard_num > 0 &&
                        (premiumTitlesCount +
                            subscription.titles?.premiumTitlesCount >
                            subscription.package.premium_num ||
                            standardTitlesCount +
                                subscription.titles?.standardTitlesCount >
                                subscription.package.standard_num) ? (
                            <Button
                                block={true}
                                variant="solid"
                                className="mb-3"
                                size="md"
                                disabled={selectedTitles.length < 1}
                                onClick={async () => {
                                    await dispatch(setPlanPanelExpand(true))
                                    closePanel()
                                }}
                            >
                                Upgrade
                            </Button>
                        ) : (
                            <Button
                                block={true}
                                variant="solid"
                                className="mb-3 text-base font-medium"
                                disabled={selectedTitles.length < 1}
                                onClick={saveSubscriptionChanges}
                                loading={loading}
                            >
                                Add Titles to My Feed
                            </Button>
                        )
                    ) : (
                        <Button
                            block={true}
                            variant="solid"
                            className="mb-3"
                            size="md"
                            disabled={selectedTitles.length < 1}
                            onClick={async () => {
                                if (userAuthority.includes(USER)) {
                                    await dispatch(setChangePackageTo(null))
                                    await dispatch(setPlanPanelExpand(true))
                                    closePanel()
                                } else {
                                    dispatch(setPanelExpand(false))
                                    dispatch(setAuthPanelSignupExpand(true))
                                }
                            }}
                        >
                            Select Plan
                        </Button>
                    )}

                    <p className="text-xs text-center text-black pb-3">
                        All plan comes with a 14-day evaluation period.
                    </p>
                </div>
            </div>
        </div>
    )

    const getDrawerWidth = () => {
        if (windowWidth < 640) return windowWidth
        if (windowWidth < 1024) return windowWidth * 0.8
        return windowWidth / 2
    }

    return (
        <>
            <Drawer
                headerClass={'hidden'}
                isOpen={panelExpand}
                onClose={closePanel}
                onRequestClose={closePanel}
                placement={direction === 'rtl' ? 'left' : 'right'}
                width={getDrawerWidth()}
                className="bg-red-400 overflow-hidden"
                bodyClass={'p-0 bg-gray-200 overflow-hidden'}
                footer={Footer}
                overlayClassName="z-40"
            >
                <div className="flex items-center mx-6 my-3 justify-between">
                    <span
                        className="cursor-pointer font-medium"
                        onClick={closePanel}
                    >
                        <IconText
                            className="text-red-600"
                            icon={<RiMenuUnfoldLine className="text-lg" />}
                        >
                            Hide Titles Cart
                        </IconText>
                    </span>
                    {selectedTitles.length > 0 && (
                        <span
                            onClick={() => dispatch(clearCheckout())}
                            className="cursor-pointer text-xs text-red-600 font-medium"
                        >
                            Clear Cart
                        </span>
                    )}
                </div>
                <div className="m-4 p-4 mb-0 pb-0 border border-b-0 bg-white h-full  flex flex-col">
                    <div className="border-b">
                        <div className="flex items-center justify-start gap-2">
                            <h3 className="font-bold mb-0 pb-0">Titles Cart</h3>
                            <Badge
                                content={selectedTitles.length}
                                maxCount={99}
                                className="text-center header-action-item-hoverable rounded-full"
                                badgeStyle={{
                                    top: '8px',
                                    right: '6px',
                                    width: 25,
                                    height: 25,
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center', // Center the badge within its container
                                    fontWeight: 700,

                                    fontSize: '10px',
                                }}
                            />
                        </div>
                        <div className="flex items-center justify-between mb-3 mt-0 pt-0">
                            <div className="flex items-start gap-1">
                                <p className="text-sm text-black">
                                    Review the titles you want to subscribe to
                                </p>
                            </div>
                            <div className="hidden">
                                <div className="flex items-center">
                                    <span className="font-medium text-black text-sm capitalize">
                                        Sort by
                                    </span>
                                    <Dropdown
                                        toggleClassName="text-cyan-500 font-medium text-sm capitalize"
                                        title="Most Popular"
                                        placement="bottom-end"
                                        onClick={onDropdownClick}
                                        disabled={
                                            true || selectedTitles.length < 1
                                        }
                                    >
                                        {dropdownItems.map((item) => (
                                            <Dropdown.Item
                                                onSelect={onDropdownItemClick}
                                                eventKey={item.key}
                                                key={item.key}
                                            >
                                                {item.name}
                                            </Dropdown.Item>
                                        ))}
                                    </Dropdown>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="flex-1 overflow-y-auto pb-10">
                        <SidePanelContent callBackClose={closePanel} />
                    </div>
                </div>
            </Drawer>
        </>
    )
}

export default withHeaderItem(SidePanel)
